import { useState } from 'react';
import { Clip } from '@/player-config/src/types/clip-types';
import { classnames } from '@/libs/utils';
import { getClipThumbnailUrl, isClipAudioContent } from '@/player-config/src/utils/clipUtils';
import Icon from '@/components/atoms/Icon';

interface ClipRemotionThumbnailProps {
  clip: Clip;
  layout?: 'default' | 'fullWidth';
  isClipUnseen?: boolean;
  isClipActive?: boolean;
}

export const ClipRemotionThumbnail = ({
  clip,
  layout = 'default',
  isClipUnseen,
  isClipActive
}: ClipRemotionThumbnailProps) => {
  const thumbnailUrl = getClipThumbnailUrl(clip);

  const [thumbnailType, setThumbnailType] = useState<'image' | 'error'>('image');

  function onThumbnailLoadError() {
    setThumbnailType('error');
  }

  if (!thumbnailUrl) {
    return null;
  }
  return (
    <div
      className={classnames(
        'relative flex items-center justify-center overflow-hidden rounded-md bg-cover bg-center bg-no-repeat shadow-lg',
        {
          'aspect-square w-[62%]': clip.asset_metadata.size === 'SQUARE',
          'aspect-[9/16] w-[35%]': clip.asset_metadata.size === 'PORTRAIT',
          'aspect-video w-[85%]': clip.asset_metadata.size === 'LANDSCAPE' && layout === 'default',
          'aspect-video w-full !rounded-none': clip.asset_metadata.size === 'LANDSCAPE' && layout === 'fullWidth',
          '!border-none': isClipUnseen && !isClipActive,
          'h-full !shadow-none': layout === 'fullWidth'
        }
      )}
    >
      {thumbnailType === 'image' ? (
        <div>
          <img
            data-testid="clip-preview-image"
            className={'mx-auto blur-0 transition-all duration-300'}
            src={thumbnailUrl}
            alt="Preview"
            onError={onThumbnailLoadError}
          />
        </div>
      ) : (
        <div className="flex size-6 items-center justify-center rounded-full border border-slate-300">
          <Icon
            name={isClipAudioContent(clip) ? 'IconHeadphones' : 'IconVideo'}
            size={13}
            stroke={2}
            className="text-slate-400/70"
          />
        </div>
      )}
    </div>
  );
};
